import RING from 'resources/ring.mp3'

export default {
  videoCallRingtone: RING,
}
